import { createBrowserHistory } from "history";

// A custom history object that enables us to redirect users from outside React components.
export const history = createBrowserHistory();
